import { Component } from '@angular/core';
import { ArticleSeoComponent } from '../article-seo';
import { ArticleTemplateComponent } from '../article-template/article-template.component';

@Component({
  selector: 'app-article-02',
  imports: [ArticleTemplateComponent],
  templateUrl: './article-02.component.html',
  styleUrls: []
})
export class Article02Component extends ArticleSeoComponent {
  protected readonly seo = {
    pageTitle: 'Análise de matrícula de imóvel antes de dar lance em leilão | Casato Brasil',
    description: 'Entenda o que avaliar na matrícula de um imóvel antes de dar um lance em leilão, incluindo histórico, ônus, ações judiciais e regularidade registral.'
  };
}
